module.exports = __webpack_public_path__ + "static/media/banner-3@2x.23fba18f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-3@2x.png
// module id = 1250
// module chunks = 1